// extracted by mini-css-extract-plugin
export default {"root":"Le450","small":"_3Mfv0","normal":"_1uEPr"};